<template>
  <v-dialog
    v-model="dialog"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
    v-if="dialog"
  >
    <div>
      <!-- dialog common header -->
      <popup-header
        class="fixed"
        v-bind:headerSaveBtn="headerSaveBtnName"
        v-on:clickSave="doSave"
        v-on:clickClose="closeModal()"
      ></popup-header>
      <!-- 제목 -->
      <v-row class="title-wrap">
        <v-col cols="12" class="big-title">결재선 변경</v-col>
      </v-row>
      <!-- 추가버튼 -->
      <v-row class="ma-0 mb-3" id="searchAreaHeight">
        <v-col cols="12" class="py-0 px-6">
          <v-btn
            color="white"
            block
            height="48"
            elevation="0"
            class="btn-add"
            @click="onOffModal(callModalName)"
          >
            결재자 추가
            <v-icon class="ml-auto" color="#a4abb2">mdi-plus</v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <!-- 결재자 리스트 -->
      <v-row class="ma-0 overflow-y-auto">
        <v-col class="px-6 pt-2">
          <v-list flat class="order-list">
            <draggable
              v-model="applUserListCopy"
              draggable=".draggable-on"
              handle=".drag-handle"
            >
              <transition-group name="list-complete">
                <v-list-item-group
                  v-for="(applItem, i) in applUserListCopy"
                  :key="applItem.agreeSabun"
                  :class="i == 0 ? 'draggable-off' : 'draggable-on'"
                >
                  <v-list-item class="px-4">
                    <v-list-item-icon @click="deleteEmp(applItem)">
                      <v-icon v-show="drafterFlg(i)">mdi-close</v-icon>
                    </v-list-item-icon>

                    <v-list-item-content>
                      <v-list-item-title
                        ><span class="name" v-text="applItem.agreeName"></span
                        ><span
                          class="sub-desc ml-2"
                          v-text="applItem.jikwee"
                        ></span
                        ><span
                          class="sub-desc divider"
                          v-text="applItem.org"
                        ></span
                      ></v-list-item-title>
                    </v-list-item-content>

                    <v-list-item-icon
                      class="ml-auto drag-handle"
                      name="draggableIcon"
                    >
                      <v-icon v-show="drafterFlg(i)">mdi-menu</v-icon>
                    </v-list-item-icon>
                  </v-list-item>
                </v-list-item-group>
              </transition-group>
            </draggable>
          </v-list>
        </v-col>
      </v-row>

      <!-- [모달] 임직원검색 -->
      <search-executives-dialog
        v-on:clickEmpSelect="addEmp"
      ></search-executives-dialog>
    </div>
  </v-dialog>
</template>

<script>
/* 결재선 변경 */
import SearchExecutivesDialog from '@/components/application/dialog/SearchExecutivesDialog.vue'; // 임직원검색 modal component
import PopupHeader from '@/components/common/PopupHeader.vue'; // dialog Header component

import Draggable from 'vuedraggable';
import dialogMixin from '@/mixins/dialogMixin.js'; // ** dialog Mixin **
import { mapGetters } from 'vuex';

export default {
  mixins: [dialogMixin],

  props: {
    applUserListProps: {
      type: [],
    },
  },
  data: () => ({
    modalName: 'change_approval_line',
    callModalName: 'search_executives',
    headerSaveBtnName: '변경',
    applUserListCopy: [],
  }),
  watch: {
    // 현재결재자목록 복사 (props로 받은 값은 변경할 수 없음)
    applUserListProps() {
      this.applUserListCopy = this.applUserListProps;
    },
  },
  computed: {
    drafterFlg() {
      return index => {
        return index == 0 ? false : true;
      };
    },
    ...mapGetters('ELA', ['GET_APPL_USER_LIST', 'GET_MGR_USER_LIST']),
  },
  methods: {
    /* 결재선 임직원추가 */
    addEmp(employee) {

      // 중복검사
      const dupResult = this.applUserListCopy.filter(
        user => user.agreeSabun == employee.sabun,
      );

      if (dupResult != '') {
        alert('이미 결재선에 추가된 임직원입니다');
        return;
      }

      // 결재선에 추가
      this.applUserListCopy.push({
        applTypeCd: '10',
        applTypeCdNm: '결재',
        gubun: '1',
        orgAppYn: 'N',
        pathSeq: this.GET_ORG_LEVEL,
        agreeEmpAlias: employee.name,
        agreeName: employee.name,
        agreeSabun: employee.sabun,
        jikwee: employee.jikweeNm == null ? '' : employee.jikweeNm,
        jikchak: employee.jikchakNm == null ? '' : employee.jikchakNm,
        org: employee.orgNm == null ? '' : employee.orgNm,
        agreeSeq: this.GET_APPL_USER_LIST.length + this.GET_MGR_USER_LIST.length + 1
      });

      // 모달닫기
      this.onOffModal(this.callModalName);
    },

    /* 결재선 임직원삭제 */
    deleteEmp(employee) {
      if (employee.applTypeCd == '30') {
        alert('기안자는 삭제할 수 없습니다.');
        return;
      }

      this.applUserListCopy.forEach((item, index) => {
        if (item.agreeSabun == employee.agreeSabun) {
          this.applUserListCopy.splice(index, 1);
        }
      });
    },

    /* 변경내용저장 */
    doSave() {
      let saveList = [];

      this.applUserListCopy.forEach((item, i) => {
        saveList.push({
          ...item,
          agreeSeq: i + 1,
        });
      });

      this.$store.commit('ELA/SET_APPL_USER_LIST', saveList);
      this.closeModal();
    },

    /* 모달호출 */
    onOffModal(modalNm) {
      this.$store.commit('DIALOG/TOGGLE_MODAL', modalNm);
    },
  },
  mounted() {},

  components: {
    PopupHeader,
    SearchExecutivesDialog,
    Draggable,
  },
};
</script>

<style>
.v-btn.btn-add {
  border-radius: 12px;
  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.12) !important;
  font-size: 1rem;
}
</style>
